<template>
  <div class="file-chart">
    <div id="chart" />
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import moment from "moment";
import { FileService } from "@/services/file.service";

export default {
  mounted() {
    this.loadChart();
  },
  methods: {
    async loadChart() {
      const data = await FileService.chart().then((response) => response.data);

      // Group data by type
      const dataGrouped = data.reduce((acc, item) => {
        const type = item.uploadable_type ? item.uploadable_type.split("\\").pop() : "GeoJSON";

        if (!acc[type]) {
          acc[type] = [];
        }

        acc[type].push(item);

        return acc;
      }, {});

      // Categories
      const monthCurrent = moment().endOf("month");
      const categories = [];

      for (let x = 0; x <= 12; x++) {
        categories.unshift(
          moment(monthCurrent).subtract(x, "month").format("Y-MM")
        );
      }

      // Series
      const series = Object.keys(dataGrouped).reduce((acc, key) => {
        const name = key;
        const data = categories.map((category) => {
          let count = 0;

          // Check if there are files uploaded for this category (month)
          if (dataGrouped[key]) {
            const found = dataGrouped[key].find(
              (value) => value.created_at_month === category
            );

            count = found ? found.count : count;
          }

          return count;
        });

        acc.push({ name, data });

        return acc;
      }, []);

      const options = {
        series,
        chart: {
          height: 500,
          type: "bar",
          stacked: true,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories,
        },
        title: {
          text: "Files By Type",
        },
      };

      const chart = new ApexCharts(document.querySelector("#chart"), options);
      chart.render();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/File/FileChart.vue